import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";
import { container } from "setup/dependency/inversify.config";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const initialState = {
  Loading: false,
  ResetEmailAddress: "",
};

export const forgotPasswordPageSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    setResetEmailAddress: (state, action) => {
      state.ResetEmailAddress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.Loading = true;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.Loading = false;
      })
      .addCase(resetPassword.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const resetPassword = createAsyncThunk(
  "ForgotPasswordPage/ResetPassword",
  async (emailAddress: string, thunkAPI) => {
    const clientPortalUsersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
    await clientPortalUsersService.resetPassword(emailAddress);
    thunkAPI.dispatch(setResetEmailAddress(emailAddress));
  }
);

export const { setResetEmailAddress } = forgotPasswordPageSlice.actions;

export const selectLoading = (state: RootState) => state.forgotPassword.Loading;
export const selectResetEmailAddress = (state: RootState) => state.forgotPassword.ResetEmailAddress;

export default forgotPasswordPageSlice.reducer;
